/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import ActionConstants from '../constants';
import { downloadCsvApi } from 'api/downloadCsv';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const downloadCsvAction = ({
  url,
  fileName,
  serviceMethod,
  isDownloadXlsx,
  isDirectUrl,
}: {
  url: string;
  fileName?: string;
  serviceMethod?: any;
  isDownloadXlsx?: boolean;
  isDirectUrl?: boolean;
}) => {
  const payload = {
    serviceMethod:
      serviceMethod ||
      downloadCsvApi.bind(null, {
        url,
        ...(isDownloadXlsx ? { isDownloadXlsx } : {}),
      }),
    actionTypeRequest: ActionConstants.GET_DOWNLOAD_CSV_REQUEST,
    extra: { fileName, url },
    isDirectUrl,
  };
  return { type: ActionConstants.GET_DOWNLOAD_CSV_ACTION, payload };
};
